import { useTranslation } from 'react-i18next';

import type { Schemas } from '../api/client.js';
import { track } from '../api/events.js';
import { LinkButton } from './ui.js';

/**
 * "Hilfe anfordern": leads to the order form of the site (US-05). No price (T-90, owner
 * 06.10.2026): the client describes the job and receives a quote at the hourly rate.
 */
export function HelpButton({
  siteId,
  service,
  findingId,
  ruleCode,
  size = 'md',
}: {
  siteId: string;
  service: Schemas['ServiceRef'];
  findingId?: string;
  ruleCode?: string;
  size?: 'md' | 'sm';
}) {
  const { t } = useTranslation();
  const query = new URLSearchParams({ service: service.code });
  if (findingId) query.set('finding', findingId);
  return (
    <LinkButton
      to={`/sites/${siteId}/help?${query.toString()}`}
      variant="primary"
      size={size}
      onClick={() =>
        track('service_request_opened', {
          serviceCode: service.code,
          ...(ruleCode ? { ruleCode } : {}),
        })
      }
    >
      {t('help.cta')}
    </LinkButton>
  );
}
